import { ConversationPurposeEntity } from "@/types/conversation";

export const POST_PROCESSING_PROMPT_MAX_LENGTH = 2000;

export type PostProcessingPromptMap = Partial<
  Record<ConversationPurposeEntity, string>
>;

export interface GetPostProcessingPromptsResponse {
  prompts: PostProcessingPromptMap;
}

export interface UpsertPostProcessingPromptRequest {
  meetingType: ConversationPurposeEntity;
  prompt: string;
}
